import Builder from './class-builder';

class GalvanizedBuilder extends Builder {

  /*
  * Render path for desktop
  */
  getRenderPathDesktop() {
    return this.renderDomain + 'galvanized-spiral/desktop/';
  }

  /*
  * Render path for mobile
  */
  getRenderPathMobile() {
    return this.renderDomain + 'galvanized-spiral/mobile/';
  }

  /*
  * Create image SKU
  */
  getRenderImage() {
    return 'SG3609' + this.getTreadProfileImage(this.selection_data.tread_profile) + this.getTreadCoveringImage(this.selection_data.tread_covering) + this.getHandrailImage(this.selection_data.handrail);
  }

  /*
  * Match tread profile SKU
  */
  getTreadProfileImage(tread_profile) {
    switch (tread_profile) {
      case 'S':
      case 'L':
      case 'R':
        return tread_profile;
      default:
        return 'S';
    }
  }

  /*
  * Match tread covering SKU
  */
  getTreadCoveringImage(tread_covering) {
    switch (tread_covering) {
      case 'S':
      case 'D':
        return tread_covering;
      case 'F':
        return 'S';
      default:
        return 'B';
    }
  }

  /*
  * Match handrail SKU
  */
  getHandrailImage(handrail) {
    switch (handrail) {
      case 'A':
      case 'V':
        return handrail;
      default:
        return 'A';
    }
  }

  /*
  * Create sku from object
  * The order of the sku matches the spreadsheet from Mary
  */
  setSku() {
    this.sku = this.selection_data.product_line + this.selection_data.width + this.selection_data.height + this.selection_data.tread_profile + this.selection_data.tread_covering + this.selection_data.handrail;
  }

  /*
  * Create object from sku
  * The order of the sku matches the spreadsheet from Mary
  */
  getSkuObject(sku) {
    var product_line,
        width,
        height,
        tread_profile,
        tread_covering,
        handrail,
        selection_data = {};

    if (sku) {
      product_line = sku.substring(0, 2);
      width = sku.substring(2, 4);
      height = sku.substring(4, 6);
      tread_profile = sku.substring(6, 7);
      tread_covering = sku.substring(7, 8);
      handrail = sku.substring(8, 9);


      selection_data = {
        'product_line' : product_line,
        'width' : width,
        'height' : height,
        'tread_profile' : tread_profile,
        'tread_covering' : tread_covering,
        'handrail' : handrail,
      }
    }

    this.selection_data = selection_data;
    return selection_data;
  }

}

export default GalvanizedBuilder;
